// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useContext, useEffect, useState} from 'react';
import styles from './form.module.less';
import cn from 'classnames';
import {Footer} from './footer';
import {t_states} from './types';
import {Input} from '../../lib/input';
import Eye_show from '../../img/hola2023/icons/16/eye_show.svg';
import Eye_hide from '../../img/hola2023/icons/16/eye_hide.svg';
import Chevron_left from '../../img/hola2023/icons/16/chevron_left.svg';
import {Button} from '../../lib/button';
import {is_valid_email} from 'zurl';
import {get_error_description} from './errors';
import {login_process} from './utils';
import hopt from 'hola_opt';
import {Captcha} from '../../login/captcha';
import {Lottie} from '../../lib/lottie';
import {img_url} from '../img_url';
import {Settings_context} from '../../settings_ctx';

interface i_login_buttons_props {
    go_to: (type:t_states, direction?: number)=>void;
    get_enc_url: ()=>string;
    can_signup: boolean;
    need_plus: boolean;
    no_banner?: boolean;
    Banner?: JSX.Element;
    can_back: boolean;
    img_set?: string;
}

export const State_login_with_email = (props: i_login_buttons_props)=>{
    const {theme} = useContext(Settings_context);
    const [email, set_email] = useState('');
    const [password, set_password] = useState('');
    const [type_password, set_type_password] = useState('password');
    const [process_state, set_process_state] = useState(login_process.state);
    const [error, set_error] = useState({
        fields: [],
        code: '',
    });
    useEffect(()=>{
        if (!password && login_process.last_process_error == 'wrong_password')
            return;
        set_error({fields: [], code: ''});
    }, [email, password]);
    useEffect(()=>{
        login_process.init_recaptcha();
        const uns_error_change = login_process.on('last_process_error_changed',
        ()=>{
            if (login_process.last_process_error == 'wrong_password')
                set_password('');
            if (login_process.last_process_error == 'recaptcha')
            {
                set_error({
                    fields: ['captcha'],
                    code: login_process.last_process_error,
                });
                return;
            }
            if (login_process.last_process_error == 'change_password')
            {
                set_error({
                    fields: ['password'],
                    code: login_process.last_process_error
                });
                return;
            }
            set_error({
                fields: login_process.last_process_error ?
                    ['email', 'password'] : [],
                code: login_process.last_process_error,
            });
        });
        const uns_state = login_process.on('state_changed', ()=>{
            set_process_state(login_process.state);
        });
        return ()=>{
            uns_error_change();
            uns_state();
        };
    }, []);
    return <div className={styles.login_buttons}>
        <div className={cn(styles.lottie_overlay,
          process_state=='in_progress' && styles.lottie_visible)}>
          <Lottie src={img_url('animation/loading.json')} width={'375px'}
            height={'375px'} autoplay loop/>
        </div>
        <div className={styles.head}>
          {props.can_back && <button className={styles.back_btn} onClick={()=>{
            props.go_to('login_buttons', -1);
          }}><Chevron_left/></button>}
          <p className={styles.login_signup_text}><b>Log in</b></p>
        </div>
        <form className={styles.login_form}>
          <Input label={'Email'} placeholder={'user@example.com'}
            on_change={set_email} value={email}
            error_style={error.fields.includes('email')}
            on_blur={()=>{
              if (!is_valid_email(email))
              {
                return set_error({fields: ['email'],
                  code: 'invalid_email'});
              }
            }}
            cl={styles.email_field}
          />
          <Input label={'Password'} placeholder={''} type={type_password}
            on_change={set_password} value={password}
            error_style={error.fields.includes('password')}
            Icon={p=>{
              return <div className={p.className}
                onClick={()=>set_type_password(type_password=='password'
                  ? 'text' : 'password')}>
                  {type_password=='password' ? <Eye_hide /> : <Eye_show/>}
                </div>;
            }}
            no_margin
            error={error.code && !error.fields.includes('captcha') ?
              get_error_description(error.code, email, props.go_to,
                props.get_enc_url, props.can_signup, props.need_plus) : ''}/>
          {hopt.mtcaptcha && hopt.mtcaptcha.enable && <Captcha
            error_style={error.fields.includes('captcha')}
            class_name={styles.login_captcha}
            on_verified={()=>{
              set_error({fields: [], code: ''});
            }} error={error}/>}
          <Button color={'black'} caption={'Log in'} no_jump
            cls={cn(styles.login_button,
              process_state=='in_progress' && styles.hidden_cta)}
            on_click={()=>{
              if (!is_valid_email(email))
              {
                set_error({fields: ['email'], code: 'invalid_email'});
                return;
              }
              if (!password)
              {
                set_error({fields: ['password'], code: 'empty_password'});
                return;
              }
              login_process.login_with_email(email, password,
                props.get_enc_url);
            }}
            disabled={!!error.code || process_state=='in_progress'}/>
        </form>
        <p className={cn(theme.p3, styles.login_forget_password)}><a
          onClick={e=>{
            e.preventDefault();
            props.go_to('reset_password');
          }}
          className={styles.underline}
          href='#'>Forgot password?</a></p>
        {props.can_signup ? <p className={cn(theme.p3,
          styles.login_signup_switch)}>Don't have
            an account? <a className={styles.underline}
              onClick={e=>{
                e.preventDefault();
                props.go_to(props.can_back ? 'signup_buttons'
                  : 'signup_with_email');
              }}
              href='#'>Sign up</a></p> : null}
          <Footer label={'Sign in'} google_terms
            img_set={props.img_set}/>
      </div>;
};
